import styled from 'styled-components'
import { IconButton } from '../../components'
import { styledColor } from '../../utils'

export const BackButtonStyled = styled(IconButton)`
  background-color: ${styledColor('white.100', 'white.16')};
  color: ${styledColor('gray.600', 'gray.500')};
  border: none;
`
